import { render } from "./InvitedFormDataTable.vue?vue&type=template&id=d622a01a&scoped=true"
import script from "./InvitedFormDataTable.vue?vue&type=script&lang=js"
export * from "./InvitedFormDataTable.vue?vue&type=script&lang=js"

import "./InvitedFormDataTable.vue?vue&type=style&index=0&id=d622a01a&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d622a01a"]])

export default __exports__